import * as React from 'react';

import Field, { Props as FieldProps } from '../Field';

const DateField = (props: FieldProps) => <Field placeholder="JJ/MM/AAAA" {...props} />;

export default DateField;
